(() => {
  const messageSelector = '.affirm-as-low-as';
  const emphasisClass = 'product__affirm-amount';
  const normalizeMonthlyLabel = (value) => value.replace(/\/mo\b/i, '/month');

  const emphasizeMessage = (message) => {
    const existingAmount = message.querySelector(`.${emphasisClass}`);
    if (existingAmount) {
      const walker = document.createTreeWalker(existingAmount, NodeFilter.SHOW_TEXT);
      let textNode = walker.nextNode();

      while (textNode) {
        const normalizedValue = normalizeMonthlyLabel(textNode.nodeValue);
        if (normalizedValue !== textNode.nodeValue) textNode.nodeValue = normalizedValue;
        textNode = walker.nextNode();
      }
      return;
    }

    const price = message.querySelector('.affirm-ala-price');
    const intervalNode = price?.nextSibling;
    const intervalMatch =
      intervalNode?.nodeType === Node.TEXT_NODE
        ? intervalNode.nodeValue?.match(/^(\s*\/(?:month|mo)\b)/i)
        : null;

    if (price && intervalMatch) {
      const amount = document.createElement('strong');
      amount.className = emphasisClass;

      price.replaceWith(amount);
      amount.append(price, normalizeMonthlyLabel(intervalMatch[0]));
      intervalNode.nodeValue = intervalNode.nodeValue.slice(intervalMatch[0].length);
      return;
    }

    const amountPattern = /\$\d[\d,]*(?:\.\d{2})?\s*\/(?:month|mo)\b/i;
    const walker = document.createTreeWalker(message, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();

    while (textNode) {
      const match = textNode.nodeValue?.match(amountPattern);
      if (match) {
        const amount = document.createElement('strong');
        amount.className = emphasisClass;
        amount.textContent = normalizeMonthlyLabel(match[0]);

        const fragment = document.createDocumentFragment();
        const matchIndex = match.index ?? 0;
        const before = textNode.nodeValue.slice(0, matchIndex);
        const after = textNode.nodeValue.slice(matchIndex + match[0].length);

        if (before) fragment.append(before);
        fragment.append(amount);
        if (after) fragment.append(after);
        textNode.replaceWith(fragment);
        return;
      }

      textNode = walker.nextNode();
    }
  };

  const scan = (root = document) => {
    if (root.matches?.(messageSelector)) emphasizeMessage(root);
    root.querySelectorAll?.(messageSelector).forEach(emphasizeMessage);
  };

  const start = () => {
    scan();
    new MutationObserver(() => scan()).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  window.LureAffirmMessaging = { scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
